import React from 'react';

import { Tag as AntdTag } from 'antd';

import { DossierSummaryResponseDto } from 'lib_api/lib/api/gen';

import { DashbardImmatriculationCell } from '../components/Dashboard/DashboardImmatriculationCell/DashboardImmatriculationCell';

import { statutEnumMapping } from './enumData';
import { getStatutFromDossier } from './StatutUtils';

export function buildImmatriculationContent(
  url: string,
  data: DossierSummaryResponseDto,
): React.ReactElement {
  return <DashbardImmatriculationCell url={url} dossier={data} />;
}

export function buildStatutContent(
  data: DossierSummaryResponseDto,
): React.ReactNode {
  const statut = getStatutFromDossier(data);

  if (statut === undefined) {
    return null;
  } else {
    const { tagColor, label } = statutEnumMapping[statut];
    return <AntdTag color={tagColor}>{label}</AntdTag>;
  }
}
